/**
 * Reason codes meaning cloud sync is *paused* (it was enabled, now blocked: expired / revoked /
 * past-due subscription). Data is kept locally and CloudBound budgets go read-only until the
 * capability is reactivated — this is NOT a downgrade (no destructive conversion). See spec §15.2.
 */
const PAUSED_REASONS = new Set([
    'CLOUD_SYNC_REVOKED',
    'SUBSCRIPTION_EXPIRED',
    'SUBSCRIPTION_PAST_DUE',
]);
export function isCloudSyncPaused(status) {
    if (!status)
        return false;
    return (!status.cloudSyncEnabled && status.reasonCode != null && PAUSED_REASONS.has(status.reasonCode));
}
/** The id of the budget a user mutation targets, or null if the action is not a budget mutation. */
function targetBudgetId(action, currentId) {
    switch (action.type) {
        case 'UPDATE_BUDGET':
        case 'TOGGLE_ARCHIVE_BUDGET':
        case 'DELETE_BUDGET':
            return action.id;
        case 'IMPORT_STATEMENT':
            return action.budgetId;
        case 'ADD_TX':
        case 'UPDATE_TX':
        case 'DELETE_TX':
        case 'UPDATE_SERIES_FROM':
        case 'DELETE_SERIES_FROM':
        case 'EXTEND_SERIES':
            // Transaction mutations always apply to the currently open budget.
            return currentId;
        default:
            // Navigation, profile, CREATE_BUDGET (new LocalOnly), INIT_DATA, and sync-internal
            // REPLACE_BUDGET_ID are never blocked.
            return null;
    }
}
/**
 * When cloud sync is paused, mutations to CloudBound budgets are blocked so the client mirrors the
 * server-side read-only enforcement and does not accumulate un-syncable changes.
 */
export function isBlockedWhilePaused(action, budgets, currentId) {
    const id = targetBudgetId(action, currentId);
    if (id == null)
        return false;
    const budget = budgets.find((b) => b.id === id);
    return budget?.storageMode === 'CloudBound';
}
